const Service           = require('gui/inputs/service');
module.exports = class FloatService extends Service {
  constructor(opts = {}) {
    super(opts);
  }
};
